import { useState } from 'react'
import {ChevronDown} from 'lucide-react'

interface FaqItem {
  question: string
  answer: string
}

function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <div className="space-y-2">
      {items.map((item, index) => {
        const isOpen = openIndex === index
        return (
          <div key={item.question} className="overflow-hidden rounded-xl border border-slate-800 bg-slate-900/50">
            <button
              onClick={() => setOpenIndex(isOpen ? null : index)}
              className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left text-sm font-medium text-slate-100"
            >
              {item.question}
              <ChevronDown className={`h-4 w-4 shrink-0 text-slate-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
            </button>
            {isOpen ? <p className="px-4 pb-4 text-sm leading-relaxed text-slate-400">{item.answer}</p> : null}
          </div>
        )
      })}
    </div>
  )
}

export default FaqAccordion
